import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";

const JavaScriptLesson3 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>Setup JavaScript</strong></h3>
    <p>To setup and run JavaScript, you must have an editor and a browser. A simple editor like Notepad can be used, but for the advantage of IntelliSense support for JavaScript and syntax error/warning highlighter for rapid development, you can install any open-sourced or licensed IDE <span class="text-primary">(Integrated Development Environment)</span>.</p>
    <p>There are several IDEs that you can use:</p>
    <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item">Visual Studio Code (Free, cross-platform)</li>
    <li class="list-group-item">Atom (Free, cross-platform)</li>
    <li class="list-group-item">Notepad++ (Free, Windows)</li>
    <li class="list-group-item">Code Lobster (Free, cross-platform)</li>
    <li class="list-group-item">Webstorm (Paid, cross-platform)</li>
    <li class="list-group-item">IntelliJ (Paid, cross-platform)</li>
    </ol>
    <p>Go ahead and use any editor of your choice.</p>

    <div style={{ height: 450 }} />
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson3
